import classnames from 'classnames'
import InfoPopup from '@components/InfoPopup'
import featureToggles from 'shared/featureToggles'
import { RateCurrency } from 'shared/price-utilities'

import { CANADA_CURRENCY, DELIVERY_COLLECT } from 'subscription-flow/constants'
import { getTaxationItems, getTaxesNames, getTaxesTotalNumber, getCurrentTaxTranslatedName } from '../../helpers'

import styles from './styles.module.scss'

const ProrataSection = ({ prorataInvoice: { items }, total, delivery, startDate }) => {
    const taxationItems = getTaxationItems(items)
    return (
        <div className={classnames('mt-6', 'justify-content-between', styles.prorataTotal)}>
            <div className="mb-4">
                <div className={classnames(styles.title, 'mb-1')}>
                    <T>subscription.purchase.prorata.title</T>
                    <span className={styles.startDate}>
                        {' '}
                        (<T>subscription.purchase.prorata.title.startedAt</T> {startDate.displayValue})
                    </span>
                </div>
                <p className="text-small">
                    <T>subscription.purchase.prorata.description</T>
                </p>
            </div>
            {items.map(
                ({ chargeName, productRatePlanChargeId, amountWithoutTax }) =>
                    amountWithoutTax > 0 && (
                        <div key={productRatePlanChargeId} className="row mt-2">
                            <div className="col-7 col-sm-10">
                                <span>{chargeName}</span>
                            </div>
                            <div className="col-4 col-sm-2 text-right font-weight-bold">
                                <RateCurrency value={amountWithoutTax} currency={CANADA_CURRENCY} />
                            </div>
                        </div>
                    )
            )}
            <hr />
            {getTaxesNames(taxationItems).map((name, index) => (
                <div className="row mt-2" key={index}>
                    <div className="col-8 col-sm-10 text-sm-right">
                        <span className="mr-3">{getCurrentTaxTranslatedName(name)}</span>
                    </div>
                    <div className="col-4 col-sm-2 text-right">
                        <RateCurrency value={getTaxesTotalNumber(name, taxationItems)} currency={CANADA_CURRENCY} />
                    </div>
                </div>
            ))}

            {delivery && (
                <div className="row mt-2">
                    <div className="col-8 col-sm-10 text-sm-right">
                        <span className="mr-3">
                            {featureToggles.hasSubcriptionLite && delivery.prdctCd === DELIVERY_COLLECT ? (
                                delivery.displayValue
                            ) : (
                                <T>subscription.purchase.prorata.shipping</T>
                            )}
                        </span>
                    </div>

                    <div className="col-4 col-sm-2 text-right">
                        <RateCurrency value={delivery.rate.amount || delivery.rate.price} currency={CANADA_CURRENCY} />
                    </div>
                </div>
            )}
            <div className={classnames('row', 'mt-2', styles.total)}>
                <div className="col-8 col-sm-10 text-sm-right">
                    <T>subscription.purchase.prorata.total</T>
                    <InfoPopup
                        className="ml-2"
                        content={<T values={{ br: <br /> }}>subscription.purchase.prorata.info.total.text</T>}
                        title={<T>subscription.purchase.prorata.info.title</T>}
                    />
                </div>
                <div className="col-4 col-sm-2 text-right">
                    <RateCurrency value={total} currency={CANADA_CURRENCY} />
                </div>
            </div>
        </div>
    )
}

export default ProrataSection
